<template>
  <data-table :dataRows="rows" :dataColumns="columns" :options="options">
    <tableTextTemplate
      slot-scope="{ row }"
      slot="expandedHeader"
      :text="row.first_name + ' ' + row.last_name"
      :link="'Member Profile'"
      :slug="row.id"
      :row="row"
      :options="{ showLinks: true, showPrimary: true }" />
    <div slot-scope="{ row }" slot="expandedRow">
      <ul class="list-unstyled mb-0 pt-2">
        <li>
          <strong>First Name: </strong>
          <tableTextTemplate :text="row.first_name" :row="row" :options="{ inline: true }"/>
        </li>
        <li>
          <strong>Last Name: </strong>
          <tableTextTemplate :text="row.last_name" :row="row" :options="{ inline: true }"/>
        </li>
        <li>
          <strong>Judge Application: </strong>
          <tablePdfIconTemplate :row="row" />
        </li>
        <li>
          <strong>Phone number: </strong>
          <tableTextTemplate
            :text="row.judge_phone === null || row.judge_phone === '' ? row.mobile_phone === null ? row.phone === null ?
              row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone"
            :row="row" />
        </li>
        <li>
          <strong>Suburb: </strong>
          <tableTextTemplate :text="row.suburb" :row="row" />
        </li>
        <li>
          <strong>Zone: </strong>
          <tableTextTemplate :text="rowZone(row.zone_id)" :row="row" />
        </li>
        <li>
          <strong>Judge Status: </strong>
          <tableTextTemplate :text="row.type.charAt(0).toUpperCase() + row.type.substring(1)" :row="row" />
        </li>
        <li>
          <button :class="['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', processing ? 'btn-primary-dark' : 'btn-primary']" @click.prevent="approve(row.judge_app_id)">
            {{ !processing ? 'Approve' : '' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
        </li>
        <li>
          <button :class="['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', processing ? 'btn-primary-dark' : 'btn-primary']" @click.prevent="deny(row.judge_app_id)">
            {{ !processing ? 'Deny' : '' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
          </button>
        </li>
      </ul>
    </div>
  </data-table>
</template>

<script>

import axios from 'axios'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tablePdfIconTemplate from '@/components/DataTableFields/PdfIcon'

export default {
  name: 'listAppsTable',
  components: {
    'data-table': dataTable,
    tableTextTemplate,
    tablePdfIconTemplate
  },
  data() {
    return {
      error: '',
      success: '',
      rows: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.first_name" :link="'Member Profile'" :slug="row.id" :row="row" :options="{ showLinks: true }" />`
          }),
          representedAs(row) { return `${row.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.last_name" :link="'Member Profile'" :slug="row.id" :row="row" :options="{ showLinks: true, showActive: true }" />`
          }),
          representedAs(row) { return `${row.last_name}` }
        },
        {
          label: 'Judge Application',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tablePdfIconTemplate },
            template: `<tablePdfIconTemplate :row="row" />`
          })
        },
        {
          label: 'Phone number',
          field: 'judge_phone',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate
              :text="row.judge_phone === null || row.judge_phone === '' ? row.mobile_phone === null ? row.phone === null ?
                row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone"
              :row="row" />`
          })
        },
        {
          label: 'Suburb',
          field: 'suburb',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.suburb" :row="row" />`
          }),
          representedAs(row) { return `${row.suburb}` }
        },
        {
          label: 'Zone',
          field: 'zone_id',
          filterable: false,
          sortable: true,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="rowZone(row.zone_id)" :row="row" />`,
            methods: {
              rowZone(theID) {
                return this.$store.state.listZones.filter(zone => zone.id === theID).length ? this.$store.state.listZones.find(zone => zone.id === theID).code : 'Unspecified'
              }
            }
          })
        },
        {
          label: 'Judge Status',
          field: 'type',
          filterable: false,
          sortable: true,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.type.charAt(0).toUpperCase() + row.type.substring(1)" :row="row" />`
          })
        },
        {
          label: 'Approve',
          field: '',
          align: 'left',
          sortable: false,
          filterable: false,
          headerClass: 'd-none d-lg-table-cell column-lg-small',
          visible: true,
          component: ({
            props: ['row'],
            template: `
              <button :class="['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', processing ? 'btn-primary-dark' : 'btn-primary']" @click.prevent="approve(row.judge_app_id)">
                {{ !processing ? 'Approve' : '' }}
                  <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
              </button>`,
            data() {
              return {
                processing: false
              }
            },
            methods: {
              approve(id) {
                this.processing = true
                axios.post(`${this.$api}/admin/judges-approve`, {
                  id
                }).then((response) => {
                  this.processing = false
                  localStorage.setItem("judge-app-status", response.data.message)
                  location.reload()
                }).catch((error) => {
                  this.status = 'undefined_error'
                  // eslint-disable-next-line
                  console.log(error)
                })
              }
            }
          })
        },
        {
          label: 'Deny',
          field: '',
          align: 'left',
          sortable: false,
          filterable: false,
          headerClass: 'd-none d-lg-table-cell column-lg-small',
          visible: true,
          component: ({
            props: ['row'],
            template: `
              <button :class="['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', processing ? 'btn-primary-dark' : 'btn-primary']" @click.prevent="deny(row.judge_app_id)">
                {{ !processing ? 'Deny' : '' }}
                  <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
              </button>`,
            data() {
              return {
                processing: false
              }
            },
            methods: {
              deny(id) {
                this.processing = true
                axios.post(`${this.$api}/admin/judges-deny`, {
                  id
                }).then((response) => {
                  this.processing = false
                  localStorage.setItem("judge-app-status", response.data.message)
                  location.reload()
                }).catch((error) => {
                  this.status = 'undefined_error'
                  // eslint-disable-next-line
                  console.log(error)
                })
              }
            }
          })
        }
      ],
      options: {
        // filter: {
        //   status: [
        //     { name: 'All', value: 'all' },
        //     { name: 'Active', value: 1 },
        //     { name: 'Suspended', value: 0 }
        //   ]
        // },
        // activeFilter: {
        //   status: 'all'
        // },
        search: true,
        loaded: false
      },
      processing: false
    }
  },
  computed: {
    listZones() {
      return this.$store.state.listZones
    }
  },
  watch: {
    listZones() {
      if (this.listZones.length > 0) {
        this.rows.map((item) => {
          const tempItem = item
          tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
          return tempItem
        })
      }
    }
  },
  mounted() {
    this.$store.commit('deselectAllRows')
    axios.get(`${this.$api}/admin/judges-apps-list`).then((response) => {
      if (response.data.status === 'success') {
        this.error = ''
        const theRows = response.data.data
        if (this.listZones.length > 0) {
          theRows.map((item) => {
            const tempItem = item
            tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
            return tempItem
          })
        }
        this.rows = theRows
        this.options.loaded = true
      } else {
        this.error = 'Unable to receive data from the server. Please reload the page.'
      }
    })
  },
  methods: {
    rowZone(theID) {
      return this.$store.state.listZones.filter(zone => zone.id === theID).length ? this.$store.state.listZones.find(zone => zone.id === theID).code : 'Unspecified'
    },
    approve(id) {
      this.processing = true
      axios.post(`${this.$api}/admin/judges-approve`, {
        id
      }).then((response) => {
        this.processing = false
        localStorage.setItem("judge-app-status", response.data.message)
        location.reload()
      }).catch((error) => {
        this.status = 'undefined_error'
        // eslint-disable-next-line
        console.log(error)
      })
    },
    deny(id) {
      this.processing = true
      axios.post(`${this.$api}/admin/judges-deny`, {
        id
      }).then((response) => {
        this.processing = false
        localStorage.setItem("judge-app-status", response.data.message)
        location.reload()
      }).catch((error) => {
        this.status = 'undefined_error'
        // eslint-disable-next-line
        console.log(error)
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/Judges/Application/components/ListAppsTable.vue